import { render, staticRenderFns } from "./table-skeleton.vue?vue&type=template&id=3f3636c4&"
import script from "./table-skeleton.vue?vue&type=script&lang=js&"
export * from "./table-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports